import type { ProductNode } from "../api/productService";

/**
 * 「可选产品」业务口径(2026-08-10 从 poster/longimage/model/productIntake 提升到 entity ——
 * 数字人「适配我的产品」也要选产品,三个消费方必须同一份判据):
 *
 * 只要 type=product、在售(status=1)、且**对外可见**的节点。
 * ★`visibility: "internal"` 的节点 attributes 里常放成本价/内部规格(这正是该字段存在的
 * 理由 —— ai sync-facts 拿它打 L0 可见性轴,internal 的事实不进公开客服 bot 与官网)。
 * 长图/海报是投给客户看的、口播是念给客户听的,内部节点进了选择器 = 成本价被画上成图/
 * 念进口播。老数据缺字段按 public 兜底(与消费侧同口径)。
 */
export function pickableProducts(nodes: ProductNode[]): ProductNode[] {
  return nodes.filter(
    (n) => n.type === "product" && n.status === 1 && (n.visibility ?? "public") === "public"
  );
}
